import { KeyboardCode } from '@dnd-kit/core'

import { FLOATING_TOOLTIP_DELAY_CONFIG } from '../../../hooks'
import { getDescSortParam } from '../../../utils/sort'

export const QA_NAME_REQUEST_BOARD = 'requestBoard'

export const QA_NAME_REQUEST_BOARD_CARD = 'requestBoardCard'

export const QA_NAME_REQUEST_BOARD_CARD_ACTIONS = 'requestBoardCardActions'

export const QA_NAME_REQUEST_BOARD_COLUMN = 'requestBoardColumn'

export const QA_NAME_REQUEST_BOARD_COLUMN_RETRY = 'requestBoardColumnRetry'

export const QA_NAME_REQUEST_BOARD_SKELETON_CARD = 'requestBoardSkeletonCard'

export const REQUEST_BOARD_COLUMN_PAGE_SIZE = 20

export const REQUEST_BOARD_COLUMN_FIRST_INDEX = 0

export const REQUEST_BOARD_ORDERING = [getDescSortParam('private_updated')]

export const REQUEST_BOARD_DROPPABLE_ID_PREFIX = 'requestBoardColumn'

export const REQUEST_BOARD_SKELETON_CARDS = ['first', 'second']

// Tab cancels a keyboard move instead of dropping the card where it is.
export const REQUEST_BOARD_KEYBOARD_CODES = {
  cancel: [KeyboardCode.Esc, KeyboardCode.Tab],
  end: [KeyboardCode.Space, KeyboardCode.Enter],
  start: [KeyboardCode.Space, KeyboardCode.Enter],
}

export const REQUEST_BOARD_CARD_TOOLTIP_REST_MARGIN_MS = 200

export const REQUEST_BOARD_CARD_TOOLTIP_HOVER_CONFIG = {
  delay: 0,
  restMs:
    FLOATING_TOOLTIP_DELAY_CONFIG.open +
    REQUEST_BOARD_CARD_TOOLTIP_REST_MARGIN_MS,
}
